module.exports = __webpack_public_path__ + "static/sec3-bg-3a25bb6b2dd33b82b7ed2a0d33c87a38.jpg";